__turbopack_context__.v({
  "menu": "InfoPageLayout-module-scss-module__vQG8aW__menu",
  "root": "InfoPageLayout-module-scss-module__vQG8aW__root",
});
